import { type FileRecord, FSType } from "./FileRecord";

/** The file, and the version of it, that a file entry stands for. */
export interface LinkTarget {
  fileId: string;
  /** Absent means the current version. */
  version?: number;
}

/**
 * The file `file` stands for: itself or, for a link, the file it points to at
 * the version the link names. Downloads fetch that file, and a link opens
 * that file's page; a link stores no object, so the service refuses to sign
 * a download URL for the link itself.
 */
export function linkTarget(file: FileRecord): LinkTarget {
  if (file.fs_type !== FSType.Link) {
    return { fileId: file.file_id };
  }

  // `roboto://file/<id>?v=<n>`: the URL parser reads `file` as the host and
  // `/<id>` as the path.
  const uri = new URL(file.uri);
  const fileId = uri.pathname.replace(/^\//, "");
  const version = uri.searchParams.get("v");

  return version === null ? { fileId } : { fileId, version: Number(version) };
}
